export const footerLinks = {
    'uz-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://uz.wingie.com/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://uz.wingie.com/flights/to-samarkand/',
                    title: 'Самарканд',
                },
                {
                    href: 'https://uz.wingie.com/flights/to-bukhara/',
                    title: 'Бухара',
                },
                {
                    href: 'https://uz.wingie.com/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://uz.wingie.com/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://uz.wingie.com/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://uz.wingie.com/flights/ru-russia/',
                    title: 'Россия',
                },
                {
                    href: 'https://uz.wingie.com/flights/tr-turkey/',
                    title: 'Турция',
                },
                {
                    href: 'https://uz.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'ОАЭ',
                },
                {
                    href: 'https://uz.wingie.com/flights/kz-kazakhstan/',
                    title: 'Казахстан',
                },
                {
                    href: 'https://uz.wingie.com/flights/kr-south-korea/',
                    title: 'Южная Корея',
                },
                {
                    href: 'https://uz.wingie.com/flights/de-germany/',
                    title: 'Германия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://uz.wingie.com/flights/airlines/uzbekistan-airways/',
                    title: 'Uzbekistan Airways',
                },
                {
                    href: 'https://uz.wingie.com/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://uz.wingie.com/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://uz.wingie.com/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://uz.wingie.com/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
                {
                    href: 'https://uz.wingie.com/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
            ],
        },
    ],
    'uz-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://uz.wingie.com/en/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/to-samarkand/',
                    title: 'Samarkand',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/to-bukhara/',
                    title: 'Bukhara',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/to-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://uz.wingie.com/en/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/tr-turkey/',
                    title: 'Turkey',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'UAE',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/kz-kazakhstan/',
                    title: 'Kazakhstan',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/kr-south-korea/',
                    title: 'South Korea',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/de-germany/',
                    title: 'Germany',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/uzbekistan-airways/',
                    title: 'Uzbekistan Airways',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
                {
                    href: 'https://uz.wingie.com/en/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
            ],
        },
    ],
    'uz-es': [
        {
            title: 'Destinos principales',
            items: [
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-samarcanda/',
                    title: 'Samarcanda',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-bujara/',
                    title: 'Bujara',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-moscu/',
                    title: 'Moscú',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubái',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://uz.wingie.com/es/vuelos/ru-rusia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/tr-turquia/',
                    title: 'Turquía',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
                    title: 'Emiratos Árabes Unidos',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/kz-kazajistan/',
                    title: 'Kazajistán',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/kr-corea-del-sur/',
                    title: 'Corea del Sur',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/de-alemania/',
                    title: 'Alemania',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/uzbekistan-airways/',
                    title: 'Uzbekistan Airways',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/fly-dubai/',
                    title: 'flydubai',
                },
                {
                    href: 'https://uz.wingie.com/es/vuelos/companias-aereas/air-astana/',
                    title: 'Air Astana',
                },
            ],
        },
    ],
    'uz-de': [
        {
            title: 'Top-Reiseziele',
            items: [
                {
                    href: 'https://uz.wingie.com/de/flug/nach-taschkent/',
                    title: 'Taschkent',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/nach-samarkand/',
                    title: 'Samarkand',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/nach-buchara/',
                    title: 'Buchara',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/nach-moskau/',
                    title: 'Moskau',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://uz.wingie.com/de/flug/ru-russland/',
                    title: 'Russland',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/tr-turkei/',
                    title: 'Türkei',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/ae-vereinigte-arabische-emirate/',
                    title: 'Vereinigte Arabische Emirate',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/kz-kasachstan/',
                    title: 'Kasachstan',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/kr-sudkorea/',
                    title: 'Südkorea',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/de-deutschland/',
                    title: 'Deutschland',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/uzbekistan-airways/',
                    title: 'Uzbekistan Airways',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/fly-dubai/',
                    title: 'flydubai',
                },
                {
                    href: 'https://uz.wingie.com/de/flug/airlines/air-astana/',
                    title: 'Air Astana',
                },
            ],
        },
    ],
    'uz-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://uz.wingie.com/ar/flights/to-tashkent/',
                    title: 'طشقند',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/to-samarkand/',
                    title: 'سمرقند',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/to-bukhara/',
                    title: 'بخارى',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/to-moscow/',
                    title: 'موسكو',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/to-istanbul/',
                    title: 'إسطنبول',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/to-dubai/',
                    title: 'دبي',
                },
            ],
        },
        {
            title: 'الدول الشعبية',
            items: [
                {
                    href: 'https://uz.wingie.com/ar/flights/ru-russia/',
                    title: 'روسيا',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/kz-kazakhstan/',
                    title: 'كازاخستان',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/kr-south-korea/',
                    title: 'كوريا الجنوبية',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/de-germany/',
                    title: 'ألمانيا',
                },
            ],
        },
        {
            title: 'شركات الطيران الشعبية',
            items: [
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/uzbekistan-airways/',
                    title: 'طيران أوزبكستان',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/aeroflot/',
                    title: 'أيروفلوت',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/s7-airlines/',
                    title: 'إس 7 إيرلاينز',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/fly-dubai/',
                    title: 'فلاي دبي',
                },
                {
                    href: 'https://uz.wingie.com/ar/flights/airlines/air-astana/',
                    title: 'طيران آستانا',
                },
            ],
        },
    ],
    'uz-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { title: 'Tashkent', href: 'https://uz.wingie.com/it/flights/to-tashkent/' },
                { title: 'Samarcanda', href: 'https://uz.wingie.com/it/flights/to-samarkand/' },
                { title: 'Bukhara', href: 'https://uz.wingie.com/it/flights/to-bukhara/' },
                { title: 'Mosca', href: 'https://uz.wingie.com/it/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/it/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://uz.wingie.com/it/flights/to-dubai/' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { title: 'Russia', href: 'https://uz.wingie.com/it/flights/ru-russia/' },
                { title: 'Turchia', href: 'https://uz.wingie.com/it/flights/tr-turkey/' },
                { title: 'Emirati Arabi Uniti', href: 'https://uz.wingie.com/it/flights/ae-united-arab-emirates/' },
                { title: 'Kazakistan', href: 'https://uz.wingie.com/it/flights/kz-kazakhstan/' },
                { title: 'Corea del Sud', href: 'https://uz.wingie.com/it/flights/kr-south-korea/' },
                { title: 'Germania', href: 'https://uz.wingie.com/it/flights/de-germany/' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/it/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/it/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/it/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/it/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/it/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/it/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-fr': [
        {
            title: 'Principales destinations',
            items: [
                { title: 'Tachkent', href: 'https://uz.wingie.com/fr/flights/to-tashkent/' },
                { title: 'Samarcande', href: 'https://uz.wingie.com/fr/flights/to-samarkand/' },
                { title: 'Boukhara', href: 'https://uz.wingie.com/fr/flights/to-bukhara/' },
                { title: 'Moscou', href: 'https://uz.wingie.com/fr/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/fr/flights/to-istanbul/' },
                { title: 'Dubaï', href: 'https://uz.wingie.com/fr/flights/to-dubai/' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { title: 'Russie', href: 'https://uz.wingie.com/fr/flights/ru-russia/' },
                { title: 'Turquie', href: 'https://uz.wingie.com/fr/flights/tr-turkey/' },
                { title: 'Émirats arabes unis', href: 'https://uz.wingie.com/fr/flights/ae-united-arab-emirates/' },
                { title: 'Kazakhstan', href: 'https://uz.wingie.com/fr/flights/kz-kazakhstan/' },
                { title: 'Corée du Sud', href: 'https://uz.wingie.com/fr/flights/kr-south-korea/' },
                { title: 'Allemagne', href: 'https://uz.wingie.com/fr/flights/de-germany/' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/fr/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/fr/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/fr/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/fr/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/fr/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/fr/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-pt': [
        {
            title: 'Principais destinos',
            items: [
                { title: 'Tashkent', href: 'https://uz.wingie.com/pt/flights/to-tashkent/' },
                { title: 'Samarcanda', href: 'https://uz.wingie.com/pt/flights/to-samarkand/' },
                { title: 'Bukhara', href: 'https://uz.wingie.com/pt/flights/to-bukhara/' },
                { title: 'Moscou', href: 'https://uz.wingie.com/pt/flights/to-moscow/' },
                { title: 'Istambul', href: 'https://uz.wingie.com/pt/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://uz.wingie.com/pt/flights/to-dubai/' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { title: 'Rússia', href: 'https://uz.wingie.com/pt/flights/ru-russia/' },
                { title: 'Turquia', href: 'https://uz.wingie.com/pt/flights/tr-turkey/' },
                { title: 'Emirados Árabes Unidos', href: 'https://uz.wingie.com/pt/flights/ae-united-arab-emirates/' },
                { title: 'Cazaquistão', href: 'https://uz.wingie.com/pt/flights/kz-kazakhstan/' },
                { title: 'Coreia do Sul', href: 'https://uz.wingie.com/pt/flights/kr-south-korea/' },
                { title: 'Alemanha', href: 'https://uz.wingie.com/pt/flights/de-germany/' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/pt/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/pt/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/pt/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/pt/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/pt/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/pt/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-ro': [
        {
            title: 'Top destinații',
            items: [
                { title: 'Tașkent', href: 'https://uz.wingie.com/ro/flights/to-tashkent/' },
                { title: 'Samarkand', href: 'https://uz.wingie.com/ro/flights/to-samarkand/' },
                { title: 'Bukhara', href: 'https://uz.wingie.com/ro/flights/to-bukhara/' },
                { title: 'Moscova', href: 'https://uz.wingie.com/ro/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/ro/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://uz.wingie.com/ro/flights/to-dubai/' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { title: 'Rusia', href: 'https://uz.wingie.com/ro/flights/ru-russia/' },
                { title: 'Turcia', href: 'https://uz.wingie.com/ro/flights/tr-turkey/' },
                { title: 'Emiratele Arabe Unite', href: 'https://uz.wingie.com/ro/flights/ae-united-arab-emirates/' },
                { title: 'Kazahstan', href: 'https://uz.wingie.com/ro/flights/kz-kazakhstan/' },
                { title: 'Coreea de Sud', href: 'https://uz.wingie.com/ro/flights/kr-south-korea/' },
                { title: 'Germania', href: 'https://uz.wingie.com/ro/flights/de-germany/' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/ro/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/ro/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/ro/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/ro/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/ro/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/ro/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { title: 'Taszkent', href: 'https://uz.wingie.com/pl/flights/to-tashkent/' },
                { title: 'Samarkanda', href: 'https://uz.wingie.com/pl/flights/to-samarkand/' },
                { title: 'Buchara', href: 'https://uz.wingie.com/pl/flights/to-bukhara/' },
                { title: 'Moskwa', href: 'https://uz.wingie.com/pl/flights/to-moscow/' },
                { title: 'Stambuł', href: 'https://uz.wingie.com/pl/flights/to-istanbul/' },
                { title: 'Dubaj', href: 'https://uz.wingie.com/pl/flights/to-dubai/' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { title: 'Rosja', href: 'https://uz.wingie.com/pl/flights/ru-russia/' },
                { title: 'Turcja', href: 'https://uz.wingie.com/pl/flights/tr-turkey/' },
                { title: 'Zjednoczone Emiraty Arabskie', href: 'https://uz.wingie.com/pl/flights/ae-united-arab-emirates/' },
                { title: 'Kazachstan', href: 'https://uz.wingie.com/pl/flights/kz-kazakhstan/' },
                { title: 'Korea Południowa', href: 'https://uz.wingie.com/pl/flights/kr-south-korea/' },
                { title: 'Niemcy', href: 'https://uz.wingie.com/pl/flights/de-germany/' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/pl/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/pl/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/pl/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/pl/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/pl/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/pl/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { title: 'Taškentas', href: 'https://uz.wingie.com/lt/flights/to-tashkent/' },
                { title: 'Samarkandas', href: 'https://uz.wingie.com/lt/flights/to-samarkand/' },
                { title: 'Buchara', href: 'https://uz.wingie.com/lt/flights/to-bukhara/' },
                { title: 'Maskva', href: 'https://uz.wingie.com/lt/flights/to-moscow/' },
                { title: 'Stambulas', href: 'https://uz.wingie.com/lt/flights/to-istanbul/' },
                { title: 'Dubajus', href: 'https://uz.wingie.com/lt/flights/to-dubai/' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { title: 'Rusija', href: 'https://uz.wingie.com/lt/flights/ru-rusija/' },
                { title: 'Turkija', href: 'https://uz.wingie.com/lt/flights/tr-turkija/' },
                { title: 'Jungtiniai Arabų Emyratai', href: 'https://uz.wingie.com/lt/flights/ae-united-arab-emirates/' },
                { title: 'Kazachstanas', href: 'https://uz.wingie.com/lt/flights/kz-kazachstanas/' },
                { title: 'Pietų Korėja', href: 'https://uz.wingie.com/lt/flights/kr-south-korea/' },
                { title: 'Vokietija', href: 'https://uz.wingie.com/lt/flights/de-vokietija/' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/lt/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/lt/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/lt/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/lt/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/lt/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/lt/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-uz': [
        {
            title: "Mashhur yo'nalishlar",
            items: [
                { title: 'Toshkent', href: 'https://uz.wingie.com/uz/flights/to-tashkent/' },
                { title: 'Samarqand', href: 'https://uz.wingie.com/uz/flights/to-samarkand/' },
                { title: 'Buxoro', href: 'https://uz.wingie.com/uz/flights/to-bukhara/' },
                { title: 'Moskva', href: 'https://uz.wingie.com/uz/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/uz/flights/to-istanbul/' },
                { title: 'Dubay', href: 'https://uz.wingie.com/uz/flights/to-dubai/' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { title: 'Rossiya', href: 'https://uz.wingie.com/uz/flights/ru-rossiya/' },
                { title: 'Turkiya', href: 'https://uz.wingie.com/uz/flights/tr-turkiya/' },
                { title: 'Birlashgan Arab Amirliklari', href: 'https://uz.wingie.com/uz/flights/ae-united-arab-emirates/' },
                { title: "Qozog'iston", href: 'https://uz.wingie.com/uz/flights/kz-qozogiston/' },
                { title: 'Janubiy Koreya', href: 'https://uz.wingie.com/uz/flights/kr-south-korea/' },
                { title: 'Germaniya', href: 'https://uz.wingie.com/uz/flights/de-germaniya/' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { title: "O'zbekiston Havo Yo'llari", href: 'https://uz.wingie.com/uz/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/uz/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/uz/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/uz/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/uz/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/uz/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-sr': [
        {
            title: 'Najpopularniji pravci',
            items: [
                { title: 'Taškent', href: 'https://uz.wingie.com/sr/flights/to-tashkent/' },
                { title: 'Samarkand', href: 'https://uz.wingie.com/sr/flights/to-samarkand/' },
                { title: 'Buhara', href: 'https://uz.wingie.com/sr/flights/to-bukhara/' },
                { title: 'Moskva', href: 'https://uz.wingie.com/sr/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/sr/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://uz.wingie.com/sr/flights/to-dubai/' },
            ],
        },
        {
            title: 'Popularne zemlje',
            items: [
                { title: 'Rusija', href: 'https://uz.wingie.com/sr/flights/ru-rusija/' },
                { title: 'Turska', href: 'https://uz.wingie.com/sr/flights/tr-turquie/' },
                { title: 'Ujedinjeni Arapski Emirati', href: 'https://uz.wingie.com/sr/flights/ae-united-arab-emirates/' },
                { title: 'Kazahstan', href: 'https://uz.wingie.com/sr/flights/kz-kazahstan/' },
                { title: 'Južna Koreja', href: 'https://uz.wingie.com/sr/flights/kr-south-korea/' },
                { title: 'Nemačka', href: 'https://uz.wingie.com/sr/flights/de-nemacka/' },
            ],
        },
        {
            title: 'Popularne avio-kompanije',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/sr/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/sr/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/sr/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/sr/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/sr/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/sr/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-ky': [
        {
            title: 'Эң популярдуу багыттар',
            items: [
                { title: 'Ташкент', href: 'https://uz.wingie.com/ky/flights/to-tashkent/' },
                { title: 'Самарканд', href: 'https://uz.wingie.com/ky/flights/to-samarkand/' },
                { title: 'Бухара', href: 'https://uz.wingie.com/ky/flights/to-bukhara/' },
                { title: 'Москва', href: 'https://uz.wingie.com/ky/flights/to-moscow/' },
                { title: 'Стамбул', href: 'https://uz.wingie.com/ky/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://uz.wingie.com/ky/flights/to-dubai/' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { title: 'Россия', href: 'https://uz.wingie.com/ky/flights/ru-russia/' },
                { title: 'Түркия', href: 'https://uz.wingie.com/ky/flights/tr-turkey/' },
                { title: 'Араб Биригген Эмираттары', href: 'https://uz.wingie.com/ky/flights/ae-united-arab-emirates/' },
                { title: 'Казакстан', href: 'https://uz.wingie.com/ky/flights/kz-kazakhstan/' },
                { title: 'Түштүк Корея', href: 'https://uz.wingie.com/ky/flights/kr-south-korea/' },
                { title: 'Германия', href: 'https://uz.wingie.com/ky/flights/de-germany/' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { title: 'Өзбекстан Аба Жолдору', href: 'https://uz.wingie.com/ky/flights/airlines/uzbekistan-airways/' },
                { title: 'Аэрофлот', href: 'https://uz.wingie.com/ky/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/ky/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/ky/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/ky/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/ky/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-tg': [
        {
            title: 'Самые популярные направления',
            items: [
                { title: 'Тошкент', href: 'https://uz.wingie.com/tg/flights/to-tashkent/' },
                { title: 'Самарқанд', href: 'https://uz.wingie.com/tg/flights/to-samarkand/' },
                { title: 'Бухоро', href: 'https://uz.wingie.com/tg/flights/to-bukhara/' },
                { title: 'Маскав', href: 'https://uz.wingie.com/tg/flights/to-moscow/' },
                { title: 'Истанбул', href: 'https://uz.wingie.com/tg/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://uz.wingie.com/tg/flights/to-dubai/' },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                { title: 'Русия', href: 'https://uz.wingie.com/tg/flights/ru-russia/' },
                { title: 'Туркия', href: 'https://uz.wingie.com/tg/flights/tr-turkey/' },
                { title: 'Имораҳои Муттаҳидаи Араб', href: 'https://uz.wingie.com/tg/flights/ae-united-arab-emirates/' },
                { title: 'Қазоқистон', href: 'https://uz.wingie.com/tg/flights/kz-kazakhstan/' },
                { title: 'Кореяи Ҷанубӣ', href: 'https://uz.wingie.com/tg/flights/kr-south-korea/' },
                { title: 'Олмон', href: 'https://uz.wingie.com/tg/flights/de-germany/' },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                { title: 'Роҳҳои Ҳавоии Ӯзбакистон', href: 'https://uz.wingie.com/tg/flights/airlines/uzbekistan-airways/' },
                { title: 'Аэрофлот', href: 'https://uz.wingie.com/tg/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/tg/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/tg/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/tg/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/tg/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-kk': [
        {
            title: 'Ең танымал бағыттар',
            items: [
                { title: 'Ташкент', href: 'https://uz.wingie.com/kk/flights/to-tashkent/' },
                { title: 'Самарқанд', href: 'https://uz.wingie.com/kk/flights/to-samarkand/' },
                { title: 'Бухара', href: 'https://uz.wingie.com/kk/flights/to-bukhara/' },
                { title: 'Мәскеу', href: 'https://uz.wingie.com/kk/flights/to-moscow/' },
                { title: 'Стамбул', href: 'https://uz.wingie.com/kk/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://uz.wingie.com/kk/flights/to-dubai/' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { title: 'Ресей', href: 'https://uz.wingie.com/kk/flights/ru-russia/' },
                { title: 'Түркия', href: 'https://uz.wingie.com/kk/flights/tr-turkey/' },
                { title: 'Біріккен Араб Әмірліктері', href: 'https://uz.wingie.com/kk/flights/ae-united-arab-emirates/' },
                { title: 'Қазақстан', href: 'https://uz.wingie.com/kk/flights/kz-kazakhstan/' },
                { title: 'Оңтүстік Корея', href: 'https://uz.wingie.com/kk/flights/kr-south-korea/' },
                { title: 'Германия', href: 'https://uz.wingie.com/kk/flights/de-germany/' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { title: 'Өзбекстан Әуе Жолдары', href: 'https://uz.wingie.com/kk/flights/airlines/uzbekistan-airways/' },
                { title: 'Аэрофлот', href: 'https://uz.wingie.com/kk/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/kk/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/kk/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/kk/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/kk/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-nl': [
        {
            title: 'Topbestemmingen',
            items: [
                { title: 'Tasjkent', href: 'https://uz.wingie.com/nl/flights/to-tashkent/' },
                { title: 'Samarkand', href: 'https://uz.wingie.com/nl/flights/to-samarkand/' },
                { title: 'Buchara', href: 'https://uz.wingie.com/nl/flights/to-bukhara/' },
                { title: 'Moskou', href: 'https://uz.wingie.com/nl/flights/to-moscow/' },
                { title: 'Istanbul', href: 'https://uz.wingie.com/nl/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://uz.wingie.com/nl/flights/to-dubai/' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { title: 'Rusland', href: 'https://uz.wingie.com/nl/flights/ru-rusland/' },
                { title: 'Turkije', href: 'https://uz.wingie.com/nl/flights/tr-turkije/' },
                { title: 'Verenigde Arabische Emiraten', href: 'https://uz.wingie.com/nl/flights/ae-united-arab-emirates/' },
                { title: 'Kazachstan', href: 'https://uz.wingie.com/nl/flights/kz-kazachstan/' },
                { title: 'Zuid-Korea', href: 'https://uz.wingie.com/nl/flights/kr-south-korea/' },
                { title: 'Duitsland', href: 'https://uz.wingie.com/nl/flights/de-duitsland/' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { title: 'Uzbekistan Airways', href: 'https://uz.wingie.com/nl/flights/airlines/uzbekistan-airways/' },
                { title: 'Aeroflot', href: 'https://uz.wingie.com/nl/flights/airlines/aeroflot/' },
                { title: 'Turkish Airlines', href: 'https://uz.wingie.com/nl/flights/airlines/turkish-airlines/' },
                { title: 'S7 Airlines', href: 'https://uz.wingie.com/nl/flights/airlines/s7-airlines/' },
                { title: 'flydubai', href: 'https://uz.wingie.com/nl/flights/airlines/fly-dubai/' },
                { title: 'Air Astana', href: 'https://uz.wingie.com/nl/flights/airlines/air-astana/' },
            ],
        },
    ],
    'uz-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://uz.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://uz.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://uz.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://uz.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://uz.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://uz.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://uz.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://uz.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://uz.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://uz.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://uz.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://uz.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://uz.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://uz.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://uz.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://uz.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://uz.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://uz.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://uz.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://uz.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://uz.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://uz.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://uz.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://uz.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://uz.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://uz.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://uz.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://uz.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://uz.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://uz.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://uz.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://uz.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://uz.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://uz.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://uz.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://uz.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://uz.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://uz.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://uz.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://uz.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://uz.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://uz.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://uz.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://uz.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://uz.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://uz.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://uz.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://uz.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://uz.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://uz.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://uz.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://uz.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://uz.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://uz.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://uz.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://uz.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://uz.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://uz.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://uz.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://uz.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://uz.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://uz.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://uz.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://uz.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://uz.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://uz.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://uz.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://uz.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://uz.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://uz.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://uz.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://uz.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://uz.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://uz.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://uz.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://uz.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://uz.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://uz.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://uz.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://uz.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://uz.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://uz.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://uz.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://uz.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://uz.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://uz.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://uz.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://uz.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://uz.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://uz.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://uz.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://uz.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://uz.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://uz.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://uz.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://uz.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://uz.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://uz.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://uz.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://uz.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://uz.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://uz.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://uz.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://uz.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://uz.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://uz.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://uz.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://uz.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://uz.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://uz.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://uz.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://uz.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://uz.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://uz.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://uz.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://uz.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://uz.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://uz.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://uz.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'uz-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://uz.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://uz.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://uz.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://uz.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://uz.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://uz.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://uz.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://uz.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://uz.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://uz.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://uz.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://uz.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://uz.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://uz.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://uz.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://uz.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://uz.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://uz.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}